// extracted by mini-css-extract-plugin
export default {"Selects":"Language_Selects__LLbVK"};